module.exports = __webpack_public_path__ + "img/hacienda-resort-7.0f65b2c5.jpg";